export { default } from './BrandedEmbeddedHeader';
export type { Props as BrandedEmbeddedHeaderProps } from './BrandedEmbeddedHeader';
